import { Data } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { NotificationDuration } from '../../../App/Models/NotificationDuration';
import { AppService, DomainTypes, Types } from '../../DomainTypes';
import InternalApprover from '../../Models/Approvals/InternalApprover';
import InternalApproverLookup from '../../Models/Approvals/Lookups/InternalApproverLookup';
import InternalApproverPagedCriteria from '../../Models/Approvals/Lookups/InternalApproverPagedCriteria';
import PortalUserLookup from '../../Models/PortalUser/Lookups/PortalUserLookup';

export default class InternalApproversComponentVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        public authorisationService = AppService.get(Types.Neo.Security.AuthorisationService),
        public apiClient = AppService.get(DomainTypes.ApiClients.InternalApprover),
        public portalUserApiClient = AppService.get(DomainTypes.ApiClients.PortalUser)) {

        super(taskRunner);
        this.makeObservable();
        this.autoDispose(this.criteria.onAnyPropertyChanged(() => this.pageManager.refreshData()))
    }

    public editItem: InternalApprover | null = null;
    public criteria = new InternalApproverPagedCriteria();

    public portalUserLookupDataSource = new Data.ApiClientLookupDataSource(
        () => this.portalUserApiClient.getPortalUserLookups(true),
        PortalUserLookup
    );

    public pageManager = new Data.PageManager(this.criteria, InternalApproverLookup, this.apiClient.getInternalApproverPaged, {
        pageSize: 20,
        initialTaskRunner: this.taskRunner,
        fetchInitial: true,
        allowSort: true,
        sortBy: 'firstName',
        sortAscending: false,
    });

    public async editInternalApprover(internalApproverId: number | null) {
        if (internalApproverId) {
            var response = await this.taskRunner.waitFor(this.apiClient.getInternalApprover(internalApproverId));
            this.editItem = InternalApprover.fromJSObject<InternalApprover>(response.data);
        }
        else {
            this.editItem = new InternalApprover();
        }
    }

    public async saveInternalApprover() {
        if (this.editItem) {
            this.taskRunner.run(async () => {
                await this.apiClient.save(this.editItem!.toJSObject());
                this.notifications.addSuccess("Save Successful", "Approver was saved successfully.", NotificationDuration.Standard);
                this.pageManager.refreshPage();
                this.editItem = null;
            });
        }
    }

    public deleteInternalApprover(internalApproverId: number) {
        this.taskRunner.run(async () => {
            await this.apiClient.delete(internalApproverId);
            this.notifications.addSuccess("Delete Successful", "Approver was deleted successfully.", NotificationDuration.Standard);
            this.pageManager.refreshData();
        });
    }
}